/**
 * Email Service
 *
 * Sends emails securely via Vercel Serverless Function (/api/send-email).
 * Optional `turnstileToken` is forwarded when provided; the API enforces it
 * only when TURNSTILE_SECRET_KEY is configured server-side, so existing
 * call sites keep working until a Turnstile widget is wired up.
 */

export interface EmailData {
  customerName: string;
  customerEmail: string;
  petName?: string;
  serviceType?: string;
  message?: string;
}

const postEmail = async (
  type: 'contact_customer' | 'contact_owner',
  data: EmailData,
  turnstileToken?: string
): Promise<boolean> => {
  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, data, turnstileToken }),
    });
    return response.ok;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(`Failed to send ${type}:`, error);
    }
    return false;
  }
};

export const sendCustomerConfirmation = (data: EmailData, turnstileToken?: string): Promise<boolean> =>
  postEmail('contact_customer', data, turnstileToken);

export const sendOwnerNotification = (data: EmailData, turnstileToken?: string): Promise<boolean> =>
  postEmail('contact_owner', data, turnstileToken);
